import {NeuronSDK} from "@neuronsearchlab/sdk";
import {getAccessToken} from "./tokenManager";
import {getBoundFetch} from "./getBoundFetch";

const BASE_URL = "https://api.neuronsearchlab.com/v1";
const COLLATE_WINDOW_SECONDS = 5;

let clientPromise = null;

export const getNeuronClient = async () => {
  const token = await getAccessToken();

  if (!clientPromise) {
    clientPromise = Promise.resolve(
      new NeuronSDK({
        baseUrl: BASE_URL,
        accessToken: token,
        fetchImpl: getBoundFetch(),
        collateWindowSeconds: COLLATE_WINDOW_SECONDS,
      })
    );
  }

  const sdk = await clientPromise;
  if (typeof sdk.setAccessToken === "function") {
    sdk.setAccessToken(token);
  }

  return sdk;
};
